import React from "react";
import ParticlesBackground from "../components/Effects/ParticlesBackground";

const Characters: React.FC = () => {
  return (
    <div>
      <ParticlesBackground />
      <h1>Personajes</h1>
      <p>Página de personajes en construcción...</p>
    </div>
  );
};

export default Characters;
